var map = {
	"./Empty-state-icon.png": 1074,
	"./HashTagIcon.png": 1075,
	"./Notification_icon.png": 1010,
	"./ProductIcon.png": 1076,
	"./arrow-icon.png": 1143,
	"./backIcon.png": 1144,
	"./big-commerce-icon.png": 1077,
	"./bottom-arrow-icon.png": 1078,
	"./brand-icon.svg": 1316,
	"./brand-safety-icon.svg": 1317,
	"./campaign.svg": 1318,
	"./campaign_icon.png": 1028,
	"./cardimage.png": 1145,
	"./carousel-create-icon.png": 1146,
	"./carousel-msg-icon.png": 1079,
	"./code-icon.png": 1080,
	"./contract-icon.svg": 1319,
	"./copy_icon.png": 995,
	"./create-campaign.png": 1081,
	"./create-carousel-icon.png": 1011,
	"./cross_icon.png": 955,
	"./delete-icon.png": 1029,
	"./dislike-icon.png": 1147,
	"./download-icon.png": 1148,
	"./download_icon.png": 980,
	"./dropbox_icon.png": 451,
	"./edit-icon.png": 1082,
	"./expand-close-icon.png": 1083,
	"./expand-open-icon.png": 1084,
	"./facebook_icon.png": 1030,
	"./google_drive_icon.png": 280,
	"./info_icon_grey.png": 1149,
	"./information_icon.png": 981,
	"./instagram_icon.png": 448,
	"./integration-icon.png": 1085,
	"./learn-more-icon.png": 1086,
	"./left-arrow-icon.png": 1087,
	"./like-icon.png": 1150,
	"./limit_reached.png": 1088,
	"./magento-icon.png": 1089,
	"./mail-icon.png": 1151,
	"./message_icon.png": 996,
	"./new_tag.png": 1090,
	"./note-delete-icon.png": 1091,
	"./notes-icon.png": 1092,
	"./open-popup-icon.png": 1031,
	"./other-icon.png": 1093,
	"./popup-close-icon.png": 1094,
	"./powered-icon.png": 1032,
	"./ratingHalfStar.png": 1152,
	"./ratingStarIcon.png": 1153,
	"./repeat-icon.png": 1069,
	"./right-arrow-icon.png": 1095,
	"./search_icon.png": 1033,
	"./selected_icon.png": 1034,
	"./share-icon.png": 1154,
	"./shopify-icon.png": 1035,
	"./sort-icon.png": 1036,
	"./sound-icon.png": 1037,
	"./squarespace-icon.png": 1038,
	"./star_fill.png": 1096,
	"./star_half.png": 1155,
	"./success-icon.png": 1097,
	"./support-icon.png": 1098,
	"./support.png": 1039,
	"./tiktok_icon.png": 449,
	"./top-arrow-icon.png": 1099,
	"./upload-icon.png": 1100,
	"./upload-time-icon.png": 1156,
	"./upload_icon.png": 993,
	"./video-icon.png": 1157,
	"./webflow-icon.png": 1101,
	"./weebly-icon.png": 1102,
	"./widget-star.png": 997,
	"./wix-icon.png": 1040,
	"./woocommerce-icon.png": 1103,
	"./wordspace-icon.png": 1104,
	"./youtube_icon.png": 457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1936;